'use client'

export function BlockContent({ children, className = '' }) {
  return (
    <div className={['nb-block-content', className].filter(Boolean).join(' ')}>
      {children}
    </div>
  )
}
